export default {
  lastDepositItem: null,
  formErrors: [],
};
